const buildPath = (category, vehicle) =>
  `/${category}s/used?brand=${encodeURIComponent(
    vehicle.brand.toLowerCase()
  )}&model=${encodeURIComponent(vehicle.model.toLowerCase())}`

module.exports = buildPath
